import { createSlice } from '@reduxjs/toolkit'
import { getTaxonomyTemplates } from "./thunks"
import { logOut } from '../authentication/authenticationSlice';
const initialState= {
  taxonomyTemplates: [],
  loading: "idle",
  error: null }

const taxonomyTemplatesSlice = createSlice({
  name: 'getTaxonomyTemplates',
  initialState,
  reducers: {
    clearTaxonomyTemplatesError: (state)=>{
      state.error = null
      state.loading = "idle"
    }
  },
  extraReducers: {
    [getTaxonomyTemplates.pending]: (state) => {
        state.loading = "loading";
        state.error = null
      },
    [getTaxonomyTemplates.fulfilled]: (state, action) => {
    state.loading = "succeeded";
    state.taxonomyTemplates = action.payload
    },
    [getTaxonomyTemplates.rejected]: (state, action) => {
        state.loading = "failed";
        state.error = action.error.message
      },
    [logOut]: (state)=> initialState
  }
})

export const {clearTaxonomyTemplatesError} = taxonomyTemplatesSlice.actions;
export default taxonomyTemplatesSlice.reducer;